export const REPORTS = [

    {
        key: "daily_working",
        label: "Daily Working Report",
        endpoint: "daily",
    },

    {
        key: "visits",
        label: "Visit Report",
        endpoint: "visits",
    },

    {
        key: "expenses",
        label: "Expense Report",
        endpoint: "expenses",
    },

    {
        key: "ta_da",
        label: "TA/DA Report",
        endpoint: "ta_da",
    },

    {
        key: "payments",
        label: "Payment Report",
        endpoint: "payments",
    },

    {
        key: "collections",
        label: "Collection Report",
        endpoint: "collections",
    },

    {
        key: "appraisals",
        label: "Appraisal Report",
        endpoint: "appraisals",
    },

    {
        key: "samples",
        label: "Sample Report",
        endpoint: "samples",
    },

    {
        key: "attendance",
        label: "Attendance Report",
        endpoint: "attendance",
    },

    {
        key: "gps_compliance",
        label: "GPS Compliance Report",
        endpoint: "gps",
    },

    {
        key: "journey_compliance",
        label: "Journey Compliance Report",
        endpoint: "journey",
    },

    {
        key: "sales_person_performance",
        label: "Sales Person Performance",
        endpoint: "performance",
    },

];


export const REPORT_API_MAP = {

    daily_working:
        "daily_working",

    visits:
        "visits",

    expenses:
        "expenses",

    ta_da:
        "ta_da",

    payments:
        "payments",

    collections:
        "collections",

    appraisals:
        "appraisals",

    samples:
        "samples",

    attendance:
        "attendance",

    gps_compliance:
        "gps_compliance",

    journey_compliance:
        "journey_compliance",

    sales_person_performance:
        "sales_person_performance",

};